// extracted by mini-css-extract-plugin
export default {"clickableTextPanelContainer":"FixedClickableTextPanel_clickableTextPanelContainer__D03IT","hidden":"FixedClickableTextPanel_hidden__Xl760"};